import { DefaultProps } from 'typings'
import styles from './styles'

export function GroupLabel(props: DefaultProps) {
  const { children } = props

  return <div className={styles.radioGroupLabel}>{children}</div>
}
